"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferPartyDtoSignatureStatusEnum = void 0;
exports.instanceOfGetOfferPartyDto = instanceOfGetOfferPartyDto;
exports.GetOfferPartyDtoFromJSON = GetOfferPartyDtoFromJSON;
exports.GetOfferPartyDtoFromJSONTyped = GetOfferPartyDtoFromJSONTyped;
exports.GetOfferPartyDtoToJSON = GetOfferPartyDtoToJSON;
exports.GetOfferPartyDtoToJSONTyped = GetOfferPartyDtoToJSONTyped;
/**
 * @export
 */
exports.GetOfferPartyDtoSignatureStatusEnum = {
    AwaitingSignature: 'awaiting_signature',
    Signed: 'signed',
    Declined: 'declined'
};
/**
 * Check if a given object implements the GetOfferPartyDto interface.
 */
function instanceOfGetOfferPartyDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('partyType' in value) || value['partyType'] === undefined)
        return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    return true;
}
function GetOfferPartyDtoFromJSON(json) {
    return GetOfferPartyDtoFromJSONTyped(json, false);
}
function GetOfferPartyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'partyType': json['partyType'],
        'isPrimary': json['isPrimary'],
        'signatureStatus': json['signatureStatus'],
        'signedAt': json['signedAt'] == null ? undefined : json['signedAt'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'isVerified': json['isVerified'] == null ? undefined : json['isVerified'],
    };
}
function GetOfferPartyDtoToJSON(json) {
    return GetOfferPartyDtoToJSONTyped(json, false);
}
function GetOfferPartyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'partyType': value['partyType'],
        'isPrimary': value['isPrimary'],
        'signatureStatus': value['signatureStatus'],
        'signedAt': value['signedAt'],
        'avatarUrl': value['avatarUrl'],
        'isVerified': value['isVerified'],
    };
}
